import { Table, Button, Space, Popconfirm } from "antd";
import React from "react";
import { useCollection } from "../../../hooks/useCollection";
import { deleteDoc, doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase/config";
import { Notification } from "../../../components/Notification";
import { AddNotification } from "../../Notifications/AddNotifications";

import { UnconfirmedGroupPricePopup } from "./UnconfirmedGroupPricePopup";
import { useAuthContext } from "../../../hooks/useAuthContext";

export default function UnconfirmedGroups() {
   //gets the data for calcuations
   const { data: data2, loading } = useCollection("clientGroups", ["approved", "==", false]);

   //gets user data
   const { user } = useAuthContext();

   //updates the data
   const updateData = async (e, docid, value) => {
      e.preventDefault();

      const ref = doc(db, "clientGroups", docid);
      await updateDoc(ref, {
         approved: true,
      })
         .then(() => {
            Notification("success", "Updated!", "Group has been updated!");
         })
         .then(() => {
            //adds the notification for the user
            AddNotification(value, "GA", user);
         })
         .catch((err) => {
            Notification("error", "Login Error", err.message);
         });
   };

   //remove group
   const removeGroup = async (value) => {
      await deleteDoc(doc(db, "clientGroups", value.id))
         .then(() => {
            Notification("success", "Deleted!", "Group has been deleted!");
         })
         .then(() => {
            //adds the notification for the user
            AddNotification(value, "GR", user);
         })
         .catch((error) => {
            Notification("error", "Error", error.message);
         });
   };

   const columns = [
      {
         title: "Group Name",
         dataIndex: "groupName",
      },
      {
         title: "User",
         dataIndex: "userEmail",
         sorter: {
            compare: (a, b) => a.userEmail - b.userEmail,
         },
      },
      {
         title: "Profitability",
         dataIndex: "profitability",
         sorter: {
            compare: (a, b) => a.profitability - b.profitability,
         },
         render: (text, value) => <UnconfirmedGroupPricePopup text={text} value={value} />,
      },
      {
         align: "center",
         render: (value) => [
            <>
               <Space>
                  <Button type="primary" onClick={(event) => updateData(event, value.id, value)}>
                     Approve!
                  </Button>
                  <Popconfirm
                     title="Delete this group?"
                     description="Are you sure to delete this ?"
                     onConfirm={() => removeGroup(value)}
                     okText="Yes"
                     cancelText="No"
                  >
                     <Button danger type="primary">
                        Delete
                     </Button>
                  </Popconfirm>
               </Space>
            </>,
         ],
      },
   ];
   return (
      <div>
         <Table columns={columns} size="small" loading={loading} dataSource={data2} pagination={{ defaultPageSize: "10" }} />
      </div>
   );
}
